import { useCallback } from 'react';
import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
export var LogLevel;
(function (LogLevel) {
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
})(LogLevel || (LogLevel = {}));
const loggerState = atomWithStorage('loggerState', {
    logLevel: LogLevel.INFO,
    logEnabled: true,
});
export function useLogger() {
    const [config, setConfig] = useAtom(loggerState);
    const onSetConfig = useCallback((config) => {
        setConfig(config);
    }, [setConfig]);
    const onLogMessage = useCallback((value, level = LogLevel.INFO) => {
        if (!config.logEnabled) {
            return;
        }
        if (level === LogLevel.ERROR) {
            console.error(value);
        }
        console.log(value);
    }, [config]);
    return [onLogMessage, config, onSetConfig];
}
